import {useMutation} from '@apollo/client';
import {Close, Delete} from '@mui/icons-material';
import {
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Slide,
  Typography,
} from '@mui/material';
import {useEffect, useState} from 'react';

import {confirmAlert} from '../../../../components/confirm-alert/confirm-alert';
import Input from '../../../../components/input/input';
import {toastNotification} from '../../../../components/toastify';
import {SAVE_MODALIDADE_E_FUNCOES} from '../../../../graphql/mutation';

export default function ModalidadeModal({modalidade = {}, open, onClose}) {
  const [formData, setFormData] = useState(modalidade);

  useEffect(() => {
    setFormData({...modalidade, funcoes: modalidade.funcoes || []});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const [saveModalidade] = useMutation(SAVE_MODALIDADE_E_FUNCOES);

  const onSaveModalidade = () => {
    if (!formData.descricao) return;

    saveModalidade({
      variables: {
        modalidade: {
          id: modalidade.id,
          descricao: formData.descricao,
          funcoes: formData.funcoes
            ?.map((f) => ({
              id: f.id,
              descricao: f.descricao,
            }))
            ?.filter((f) => !!f.descricao),
        },
      },
    })
      .then(onClose)
      .catch((error) =>
        toastNotification({message: error.message, type: 'error'}),
      );
  };

  useEffect(() => {
    if (open) return;

    setFormData({});
  }, [open]);

  const onDeleteFuncao = (index) => {
    confirmAlert({
      title: 'Deseja excluir a função?',
      onConfirm: () => {
        formData.funcoes.splice(index, 1);
        setFormData((f) => ({...f}));
      },
    });
  };

  return (
    <Modal open={open} onClose={onClose} sx={styles.modal}>
      <Slide in={open} appear>
        <Grid
          container
          className="styled-scroll-transparent-desktop"
          sx={styles.container}>
          <Grid container item sx={styles.header}>
            <Typography sx={styles.title}>MODALIDADE</Typography>
            <IconButton sx={styles.closeIcon} onClick={onClose}>
              <Close />
            </IconButton>
          </Grid>
          <Grid container sx={styles.content}>
            <Grid container item spacing={2}>
              <Grid item xs={12}>
                <Input
                  label="Descricao"
                  placeholder={'Descriçao'}
                  name="descricao"
                  type="text"
                  value={formData.descricao || ''}
                  onChange={({target}) =>
                    setFormData((f) => ({...f, descricao: target?.value}))
                  }
                />
              </Grid>
              <Grid item xs={12} marginTop={2}>
                <Divider sx={{borderColor: '#fff'}} />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={styles.subtitle}>Funções</Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  id="outlined"
                  fullWidth
                  onClick={() => {
                    formData.funcoes.unshift({});
                    setFormData((f) => ({...f}));
                  }}>
                  Adicionar +
                </Button>
              </Grid>
              {formData.funcoes?.map((funcao, index) => (
                <Grid container columnGap={2} item xs={12}>
                  <Grid item xs>
                    <Input
                      placeholder={'Descriçao'}
                      name="descricao"
                      type="text"
                      value={funcao.descricao || ''}
                      onChange={({target}) => {
                        formData.funcoes[index].descricao = target?.value;
                        setFormData((f) => ({...f}));
                      }}
                    />
                  </Grid>
                  <IconButton
                    id="icon-outlined"
                    onClick={() => {
                      onDeleteFuncao(index);
                    }}>
                    <Delete />
                  </IconButton>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} paddingTop={4}>
              <Button id="primary" onClick={onSaveModalidade}>
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
    </Modal>
  );
}

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    maxHeight: '90vh',
    width: '50%',
    borderRadius: '6px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 3,
    paddingTop: 0,
    zIndex: (theme) => theme.zIndex.modal,
    background: (theme) => theme.palette.blackSecundary,
    boxShadow: '0px 0px 134.60001px 0px rgba(255, 204, 41, 0.25)',
    outline: 'none',
    overflowY: 'auto',

    '@media (max-width: 900px)': {
      width: '90%',
    },
  },
  header: {
    flexGrow: 0,
    padding: 2,
    justifyContent: 'space-between',
    svg: {
      color: '#fff',
    },
  },
  closeIcon: {
    width: '32px',
    height: '32px',
  },
  title: {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Now',
    fontSize: '24px',
    fontWeight: '700',
    textTransform: 'uppercase',

    '@media (max-width: 1200px)': {
      fontSize: '20px',
    },
  },
  content: {
    flexDirection: 'row',
    width: '100%',
    padding: '16px',
  },
  subtitle: {
    color: '#FFF',
    fontFamily: 'Now',
    fontWeight: '700',
  },
};
